import { combineReducers } from 'redux'

import list from './list/slice'

const employersReducer = combineReducers({
  list,
})

export default employersReducer
